import React from "react";
import { ChevronDown } from "lucide-react";

// Little animated scroll indicator used at the bottom of every hero.
const ScrollCue = ({ right = null }) => (
  <div className="absolute bottom-5 left-0 right-0 flex justify-between items-end px-6 md:px-10 mx-auto text-[10px] uppercase tracking-[0.3em] text-ink/60">
    <span className="inline-flex items-center gap-2">
      Scroll
      <ChevronDown className="w-4 h-4 animate-scroll-cue" />
    </span>
    {right && <span>{right}</span>}
  </div>
);

export default ScrollCue;
